<div id="angularRoot">
  <canvas baseChart="" [datasets]="chartData?.datasets" id="547198e6-3a92-2bb1-2fd8-713d5d93c017" height="100" width="75" *ngIf="isKitKat()" [options]="options" chartType="bubble"></canvas>
  <canvas baseChart="" [datasets]="chartData?.datasets" id="648b8996-342b-76df-6e03-36e678848db8" *ngIf="!isKitKat()" [options]="options" chartType="bubble"></canvas>
</div>


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/vschartsComponent/vscharts.template.html